import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useTheme } from 'styled-components';
import Icons from '../../../../Elements/Icons/index.js';
import { InfoTooltipIcon } from '../../../../Feedback/InfoTooltipIcon/index.js';
import { useTableContext } from '../../context.js';
import { TableCellInnerWrapper } from '../TableCell/styled.js';
import { TableHeadWrapper } from './styled.js';
export const TableHead = memo(function TableHead({ children, className, dataTestId, $sticky, $compact, ...props }) {
    const { order, handleChangeOrder, tooltip } = props;
    const { colors } = useTheme();
    const { compact: tableCompact } = useTableContext();
    return (_jsx(TableHeadWrapper, { ...props, className: className, sortable: !!handleChangeOrder, onClick: handleChangeOrder, "data-testid": dataTestId, $sticky: $sticky, $compact: $compact ?? tableCompact, children: _jsxs(TableCellInnerWrapper, { ...props, noWrap: true, children: [handleChangeOrder && (_jsx(Icons.Arrow, { size: 16, color: order ? colors.main : colors.black_1, align: order === 'ASC' ? 'top' : 'bottom' })), children, tooltip && _jsx(InfoTooltipIcon, { tooltip: tooltip })] }) }));
});
